<style>
.loader {
  width: 48px;
  height: 48px;
  border: 5px solid #FFF;
  border-bottom-color: var(--bs-primary);
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

.mini-loader-container{
  position: fixed;
  top: 0;
  left: 0;
  width: 48px;
  height: 48px;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>

<template>
  <div class="mini-loader-container" v-if="show">
    <div class="loader"></div>
  </div>
</template>


<script>
export default {
  name: 'KMiniLoader',
  components: {
  },
  data(){
    return{
      show:false
    }
  },
  mounted() {
    this.$store.subscribe(async (mutation, state) => {
      if(mutation.type==='showMiniLoader'){
        this.show=true;
      }
      if(mutation.type==='hideMiniLoader'){
        this.show=false;
      }
    })
  },
};
</script>